import React, { useState, useRef, useEffect } from 'react';
import ReactPlayer from 'react-player';
import { LoaderIcon, PlayIcon, PauseIcon, Image, Slider, SLIDER_TRACK_SIZE, SoundMutedIcon, SoundIcon, FocusManager, ContextMenuIcon, DownloadIcon, SLIDER_THUMB_VISIBILITY, PlaybackIcon } from 'wix-rich-content-ui-components';
import { AUDIO_TYPE } from 'ricos-content';
import { Node_Type } from 'ricos-types';
import classNames from 'classnames';
import { getImageSrc } from 'wix-rich-content-common/libs/imageUtils';
import { KEYS_CHARCODE, ClickOutside } from 'wix-rich-content-editor-common';
import { debounce } from 'lodash';

var styles = {"fontElementMap":"U6pbI","customPlayer":"aIYbM","customPlayer_basic":"yWGpc","customPlayer_mobile":"_7yy7w","audio_coverImg":"hu6KX","audio_small_cover_image":"_0MH8n","audio_icon_button":"yEqrj","audio_contextMenu_wrapper":"sTDA-","customPlayer_with_image":"db4In","track_wrapper":"vGYOv","trackContainer":"PWLEJ","audio_download_icon":"LGntK","audio_duration":"FixzP","customPlayer_small_fit":"zAH1F","track_sliders_wrapper":"_5yXSW","audio_volume_wrapper":"zDlt3","volume_slider_wrapper":"-Z3Mj","audioDetails":"_4nUa3","title":"j8Da5","author_name":"TG3k8","dropdown_menu_wrapper":"KUoG-","dropdown_selected_button":"_7mqbr","dropdown_content":"jxLlF","dropdown_content_withIcon":"IMHdF","audio_loader_icon":"_1h-Vi","spin":"QEi83"};

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var modalContentStyles = {
  width: 363,
  padding: 20,
  boxSizing: "border-box",
  border: "solid 1px rgba(51, 51, 51, 0.1)",
  borderRadius: "var(--ricos-settings-whitebox-border-radius, 2px)",
  boxShadow: "var(--ricos-settings-whitebox-box-shadow, 0 0 10px 0 rgba(0, 0, 0, 0.06))"
};
__spreadValues({
  height: 232
}, modalContentStyles);
__spreadValues({
  height: 180
}, modalContentStyles);
var downloadFile = function downloadFile(url, fileName) {
  fetch(url, {
    method: "GET"
  }).then(function (response) {
    return response.blob();
  }).then(function (blob) {
    var url2 = window.URL.createObjectURL(blob);
    var a = document.createElement("a");
    a.href = url2;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
  });
};
var getAudioSrc = function getAudioSrc(src, settings) {
  if (src == null ? void 0 : src.url) return src.url;
  if (typeof src === "object") {
    if (settings && settings.getAudioUrl) {
      return settings.getAudioUrl(src);
    } else {
      console.error("must set getAudioUrl in plugin config when using custom audio source!", src);
    }
  }
  return src;
};
var playbackRates = [{
  text: "0.25",
  rate: 0.25
}, {
  text: "0.5",
  rate: 0.5
}, {
  text: "0.75",
  rate: 0.75
}, {
  text: "Normal",
  rate: 1
}, {
  text: "1.25",
  rate: 1.25
}, {
  text: "1.5",
  rate: 1.5
}, {
  text: "1.75",
  rate: 1.75
}, {
  text: "2",
  rate: 2
}];
var AUDIO_ACTION_NAMES = {
  fileDownloaded: "fileDownloaded",
  playAudio: "playAudio",
  changeTitle: "changeTitle",
  changeCreator: "changeCreator",
  changeCover: "changeCover",
  downloadAudio: "downloadAudio"
};
var AUDIO_BI_VALUES = {
  PLAY: "play",
  PAUSE: "pause",
  PLAYBACK_COMPLETED: "playbackCompleted",
  YES: "yes",
  NO: "no",
  click: "Click"
};
var AUDIO_TYPES = {
  custom: "File Upload",
  spotify: "Spotify",
  soundCloud: "SoundCloud"
};
({
  insert: Node_Type.AUDIO + ".insert",
  settings: Node_Type.AUDIO + ".settings",
  insertAudio: Node_Type.AUDIO + ".insertAudio",
  insertSoundCloud: Node_Type.AUDIO + ".insertSoundCloud",
  insertSpotify: Node_Type.AUDIO + ".insertSpotify",
  replace: Node_Type.AUDIO + ".replace"
});
({
  size: Node_Type.AUDIO + ".size",
  alignment: Node_Type.AUDIO + ".alignment"
});

var AudioActionIcons = function AudioActionIcons(_ref) {
  var isPlaying = _ref.isPlaying,
    handlePause = _ref.handlePause,
    handlePlay = _ref.handlePlay,
    disabled = _ref.disabled,
    isLoading = _ref.isLoading,
    helpers = _ref.helpers;
  var onClick = function onClick() {
    var _a;
    var ACTION_BI_VALUE = isPlaying ? AUDIO_BI_VALUES.PAUSE : AUDIO_BI_VALUES.PLAY;
    (_a = helpers == null ? void 0 : helpers.onViewerAction) == null ? void 0 : _a.call(helpers, AUDIO_TYPE, AUDIO_ACTION_NAMES.playAudio, ACTION_BI_VALUE);
    isPlaying ? handlePause() : handlePlay();
  };
  var onKeyPress = function onKeyPress(e) {
    if (e.key === "Enter") {
      onClick();
    }
  };
  var ComponentIcon = disabled || !isPlaying ? PlayIcon : PauseIcon;
  var ariaLabel = isPlaying ? "pause" : "play";
  return isLoading ? /* @__PURE__ */React.createElement(LoaderIcon, {
    className: styles.audio_loader_icon
  }) : /* @__PURE__ */React.createElement("button", {
    className: styles.audio_icon_button,
    onClick: onClick,
    onKeyPress: onKeyPress,
    "aria-label": ariaLabel
  }, /* @__PURE__ */React.createElement(ComponentIcon, null));
};

var AudioDetails = function AudioDetails(_ref) {
  var authorName = _ref.authorName,
    title = _ref.title;
  return /* @__PURE__ */React.createElement("div", {
    className: styles.audioDetails
  }, title && /* @__PURE__ */React.createElement("span", {
    className: styles.title
  }, title), authorName && /* @__PURE__ */React.createElement("span", {
    className: styles.author_name
  }, authorName));
};

var Duration = function Duration(_ref) {
  var seconds = _ref.seconds;
  return /* @__PURE__ */React.createElement("time", {
    dateTime: "P" + Math.round(seconds) + "S"
  }, format(seconds));
};
function format(seconds) {
  var date = new Date(seconds * 1e3);
  var hh = date.getUTCHours();
  var mm = date.getUTCMinutes();
  var ss = pad(date.getUTCSeconds());
  if (hh) {
    return hh + ":" + pad(mm) + ":" + ss;
  }
  return mm + ":" + ss;
}
function pad(string) {
  return ("0" + string).slice(-2);
}
var AudioDuration = function AudioDuration(_ref2) {
  var elapsed = _ref2.elapsed,
    duration = _ref2.duration,
    isMobile = _ref2.isMobile,
    isSmallWidth = _ref2.isSmallWidth;
  var shouldRenderElapsed = !(isMobile || isSmallWidth);
  return /* @__PURE__ */React.createElement("div", {
    className: styles.audio_duration
  }, shouldRenderElapsed && /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement(Duration, {
    seconds: elapsed
  }), " /"), /* @__PURE__ */React.createElement(Duration, {
    seconds: duration
  }));
};

var AudioImage = function AudioImage(_ref) {
  var _classNames;
  var getImageUrl = _ref.getImageUrl,
    coverImage = _ref.coverImage,
    isSmallImage = _ref.isSmallImage;
  return /* @__PURE__ */React.createElement(Image, {
    src: getImageSrc({
      file_name: coverImage.src
    }, getImageUrl, {
      requiredWidth: 84,
      requiredHeight: 84,
      requiredQuality: 70
    }),
    className: classNames(styles.audio_coverImg, (_classNames = {}, _classNames[styles.audio_small_cover_image] = isSmallImage, _classNames)),
    resizeMode: "cover",
    theme: styles
  });
};

var SoundControl = function SoundControl(_ref) {
  var volume = _ref.volume,
    muted = _ref.muted,
    handleMute = _ref.handleMute,
    theme = _ref.theme,
    handleVolumeChange = _ref.handleVolumeChange;
  var onKeyPress = function onKeyPress(e) {
    if (e.key === "Enter") {
      handleMute();
    }
  };
  var onKeyDown = function onKeyDown(e) {
    var shouldDecrease = e.key === "ArrowDown" && volume > 0;
    var shouldIncrease = e.key === "ArrowUp" && volume < 1;
    var newVolume = shouldDecrease ? volume - 0.1 : shouldIncrease ? volume + 0.1 : volume;
    handleVolumeChange(parseFloat(newVolume.toFixed(1)));
  };
  var SoundIconComponent = muted ? SoundMutedIcon : SoundIcon;
  return /* @__PURE__ */React.createElement("button", {
    className: classNames(styles.audio_icon_button, styles.audio_volume_wrapper),
    onKeyPress: onKeyPress,
    onKeyDown: onKeyDown,
    "aria-label": "sound"
  }, /* @__PURE__ */React.createElement("div", {
    className: styles.volume_slider_wrapper
  }, /* @__PURE__ */React.createElement(Slider, {
    theme: theme,
    min: 0,
    max: 1,
    step: "any",
    value: volume,
    onChange: handleVolumeChange,
    onChangeCommitted: handleVolumeChange,
    languageDir: "ltr",
    dataHook: "audioVolumeSlider",
    trackSize: SLIDER_TRACK_SIZE.small,
    liveSiteWiring: true,
    tabIndex: -1
  })), /* @__PURE__ */React.createElement(SoundIconComponent, {
    className: styles.audio_sound_icon,
    onClick: handleMute
  }));
};

var optionElement = function optionElement(option) {
  var selected = option == null ? void 0 : option.selected;
  var content = option.icon ? /* @__PURE__ */React.createElement("span", {
    className: styles.dropdown_content_withIcon
  }, option.icon(), option.text) : /* @__PURE__ */React.createElement("span", {
    className: styles.dropdown_content
  }, option.text);
  var onKeyDown = function onKeyDown(e) {
    if (e.keyCode === KEYS_CHARCODE.ENTER) {
      option.onClick();
    }
  };
  return /* @__PURE__ */React.createElement("button", {
    key: option.text,
    className: selected ? styles.dropdown_selected_button : "",
    onKeyDown: onKeyDown,
    onClick: option.onClick,
    "data-hook": option == null ? void 0 : option.dataHook
  }, content);
};
var DropdownMenu = function DropdownMenu(_ref) {
  var options = _ref.options,
    onClose = _ref.onClose;
  var onKeyDown = function onKeyDown(e) {
    if (e.keyCode === KEYS_CHARCODE.ESCAPE) {
      onClose();
    }
  };
  return /* @__PURE__ */React.createElement(FocusManager, {
    onKeyDown: onKeyDown
  }, /* @__PURE__ */React.createElement("div", {
    className: styles.dropdown_menu_wrapper
  }, options.map(function (option) {
    return optionElement(option);
  })));
};

var ContextMenu = function ContextMenu(_ref) {
  var onClickOutside = _ref.onClickOutside,
    contextMenuData = _ref.contextMenuData,
    playBackMenuData = _ref.playBackMenuData,
    showContextMenu = _ref.showContextMenu,
    showPlaybackMenu = _ref.showPlaybackMenu,
    onClick = _ref.onClick;
  var onKeyPress = function onKeyPress(e) {
    if (e.key === "Enter") {
      onClick();
    }
  };
  return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement(ClickOutside, {
    onClickOutside: onClickOutside
  }, showContextMenu && /* @__PURE__ */React.createElement(DropdownMenu, {
    options: contextMenuData,
    onClose: onClickOutside
  }), showPlaybackMenu && /* @__PURE__ */React.createElement(DropdownMenu, {
    options: playBackMenuData,
    onClose: onClickOutside
  })), /* @__PURE__ */React.createElement(ContextMenuIcon, {
    "data-hook": "audioContextMenu",
    tabIndex: 0,
    onKeyPress: onKeyPress,
    className: styles.audio_contextMenuIcon,
    onClick: onClick,
    "aria-label": "context menu"
  }));
};

var ReactPlayerWrapper = function ReactPlayerWrapper(_ref) {
  var _classNames;
  var url = _ref.url,
    authorName = _ref.authorName,
    name = _ref.name,
    disableDownload = _ref.disableDownload,
    coverImage = _ref.coverImage,
    helpers = _ref.helpers,
    isMobile = _ref.isMobile,
    showControls = _ref.showControls,
    disabled = _ref.disabled,
    theme = _ref.theme,
    isLoading = _ref.isLoading,
    saveDurationToData = _ref.saveDurationToData,
    isDownloadDisabled = _ref.isDownloadDisabled;
  var _useState = useState(url),
    URL = _useState[0],
    setURL = _useState[1];
  var _useState2 = useState(false),
    isPlaying = _useState2[0],
    setIsPlaying = _useState2[1];
  var _useState3 = useState(0),
    duration = _useState3[0],
    setDuration = _useState3[1];
  var _useState4 = useState(false),
    seeking = _useState4[0],
    setSeeking = _useState4[1];
  var _useState5 = useState(0),
    played = _useState5[0],
    setPlayed = _useState5[1];
  var _useState6 = useState(1),
    volume = _useState6[0],
    setVolume = _useState6[1];
  var _useState7 = useState(1),
    lastVolume = _useState7[0],
    setLastVolume = _useState7[1];
  var _useState8 = useState(1),
    playbackRate = _useState8[0],
    setPlaybackRate = _useState8[1];
  var _useState9 = useState(false),
    showPlaybackMenu = _useState9[0],
    setShowPlaybackMenu = _useState9[1];
  var _useState10 = useState(false),
    showContextMenu = _useState10[0],
    setShowContextMenu = _useState10[1];
  var _useState11 = useState(false),
    isStoppedBySeek = _useState11[0],
    setIsStoppedBySeek = _useState11[1];
  var _useState12 = useState(0),
    currentWidth = _useState12[0],
    setCurrentWidth = _useState12[1];
  var resizeWidths = {
    small: 320
  };
  var reactPlayerSize = showControls ? "100%" : 0;
  var hasDetails = authorName || name;
  var reactPlayerRef = useRef(null);
  var customPlayerRef = useRef(null);
  var onDownload = function onDownload() {
    return downloadFile(URL, name || "untitled");
  };
  var showMobileDownloadIcon = isMobile && hasDetails && !disableDownload && !isDownloadDisabled;
  var playBackMenuData = playbackRates.map(function (_ref2) {
    var text = _ref2.text,
      rate = _ref2.rate;
    return {
      text: text,
      onClick: function onClick() {
        setPlaybackRate(rate);
        setShowPlaybackMenu(false);
      },
      selected: playbackRate === rate
    };
  });
  var contextMenuOptions = {
    download: {
      text: "Download",
      onClick: function onClick() {
        var _a;
        (_a = helpers == null ? void 0 : helpers.onViewerAction) == null ? void 0 : _a.call(helpers, AUDIO_TYPE, AUDIO_ACTION_NAMES.fileDownloaded, AUDIO_BI_VALUES.click);
        onDownload();
        setShowContextMenu(false);
      },
      dataHook: "audioDownloadIcon",
      icon: DownloadIcon
    },
    playback: {
      text: "Playback Speed",
      onClick: function onClick() {
        setShowContextMenu(false);
        setShowPlaybackMenu(true);
      },
      dataHook: "audioPlaybackIcon",
      icon: PlaybackIcon
    }
  };
  var contextMenuData = disableDownload ? [contextMenuOptions.playback] : [contextMenuOptions.download, contextMenuOptions.playback];
  var handleProgress = function handleProgress(state) {
    if (!seeking) {
      setPlayed(state.played);
    }
  };
  var onEnded = function onEnded() {
    var _a;
    return (_a = helpers == null ? void 0 : helpers.onViewerAction) == null ? void 0 : _a.call(helpers, AUDIO_TYPE, AUDIO_ACTION_NAMES.playAudio, AUDIO_BI_VALUES.PLAYBACK_COMPLETED);
  };
  var handleDuration = function handleDuration(num) {
    var _a;
    setDuration(num);
    saveDurationToData(num);
    var audioType = showControls ? AUDIO_TYPES.soundCloud : AUDIO_TYPES.custom;
    (_a = helpers == null ? void 0 : helpers.mediaPluginsDetails) == null ? void 0 : _a.call(helpers, {
      pluginId: AUDIO_TYPE,
      creator: authorName,
      title: name,
      track_duration: num == null ? void 0 : num.toString(),
      type: audioType,
      url: url
    });
  };
  var handleSeekChange = function handleSeekChange(num) {
    isPlaying && setIsStoppedBySeek(true);
    handlePause();
    setSeeking(true);
    setPlayed(num);
  };
  var handlePlay = function handlePlay() {
    return setIsPlaying(true);
  };
  var handlePause = function handlePause() {
    return setIsPlaying(false);
  };
  var handleContextMenuClick = function handleContextMenuClick() {
    showContextMenu || showPlaybackMenu ? onClickOutside() : setShowContextMenu(true);
  };
  var handleSeekMouseUp = function handleSeekMouseUp(num) {
    var _a;
    (_a = reactPlayerRef == null ? void 0 : reactPlayerRef.current) == null ? void 0 : _a.seekTo(num);
    setSeeking(false);
    isStoppedBySeek && handlePlay();
    setIsStoppedBySeek(false);
  };
  var handleMute = function handleMute() {
    if (volume !== 0) {
      setLastVolume(volume);
      setVolume(0);
    } else {
      setVolume(lastVolume);
    }
  };
  var onClickOutside = function onClickOutside() {
    setShowContextMenu(false);
    setShowPlaybackMenu(false);
  };
  var renderAudioDuration = function renderAudioDuration() {
    return /* @__PURE__ */React.createElement(AudioDuration, {
      elapsed: played * duration,
      duration: duration,
      isMobile: isMobile,
      isSmallWidth: resizeWidths.small >= currentWidth
    });
  };
  useEffect(function () {
    handlePause();
    setURL(url);
  }, [showControls, url]);
  useEffect(function () {
    var _a;
    (_a = reactPlayerRef.current) == null ? void 0 : _a.seekTo(0);
  }, []);
  useEffect(function () {
    var _a;
    var resizer;
    if (window == null ? void 0 : window.ResizeObserver) {
      resizer = new ResizeObserver(debounce(function (entries) {
        setCurrentWidth(Math.round(entries[0].contentRect.width));
      }, 60));
    }
    customPlayerRef.current && ((_a = resizer == null ? void 0 : resizer.observe) == null ? void 0 : _a.call(resizer, customPlayerRef == null ? void 0 : customPlayerRef.current));
  }, []);
  return /* @__PURE__ */React.createElement("div", null, !showControls && /* @__PURE__ */React.createElement("div", {
    className: classNames(styles.customPlayer, (_classNames = {}, _classNames[styles.customPlayer_basic] = !hasDetails, _classNames[styles.customPlayer_small_fit] = resizeWidths.small >= currentWidth, _classNames[styles.customPlayer_mobile] = isMobile, _classNames[styles.customPlayer_with_image] = coverImage == null ? void 0 : coverImage.src, _classNames)),
    ref: customPlayerRef
  }, (coverImage == null ? void 0 : coverImage.src) && /* @__PURE__ */React.createElement(AudioImage, {
    coverImage: coverImage,
    getImageUrl: helpers == null ? void 0 : helpers.getImageUrl,
    isSmallImage: !hasDetails
  }), /* @__PURE__ */React.createElement("div", {
    className: styles.track_wrapper
  }, hasDetails && /* @__PURE__ */React.createElement(AudioDetails, {
    authorName: authorName,
    title: name
  }), showMobileDownloadIcon && /* @__PURE__ */React.createElement(DownloadIcon, {
    className: styles.audio_download_icon,
    onClick: onDownload
  }), /* @__PURE__ */React.createElement("div", {
    className: styles.trackContainer
  }, /* @__PURE__ */React.createElement(AudioActionIcons, {
    handlePlay: handlePlay,
    handlePause: handlePause,
    isPlaying: isPlaying,
    disabled: disabled,
    isLoading: isLoading,
    helpers: helpers
  }), !isMobile && renderAudioDuration(), /* @__PURE__ */React.createElement("div", {
    className: styles.track_sliders_wrapper
  }, /* @__PURE__ */React.createElement(Slider, {
    theme: theme,
    languageDir: "ltr",
    value: played,
    dataHook: "audioSlider",
    onChange: handleSeekChange,
    onChangeCommitted: handleSeekMouseUp,
    step: "any",
    min: 0,
    max: 1,
    thumbVisibility: SLIDER_THUMB_VISIBILITY.hover,
    trackSize: SLIDER_TRACK_SIZE.small,
    liveSiteWiring: true,
    ariaLabel: "audio Slider"
  }), /* @__PURE__ */React.createElement(SoundControl, {
    theme: theme,
    volume: volume,
    handleMute: handleMute,
    muted: volume === 0,
    handleVolumeChange: setVolume
  })), isMobile && renderAudioDuration(), !isMobile && /* @__PURE__ */React.createElement("button", {
    className: styles.audio_contextMenu_wrapper,
    tabIndex: -1
  }, /* @__PURE__ */React.createElement(ContextMenu, {
    onClickOutside: onClickOutside,
    contextMenuData: contextMenuData,
    playBackMenuData: playBackMenuData,
    showContextMenu: showContextMenu,
    showPlaybackMenu: showPlaybackMenu,
    onClick: handleContextMenuClick
  }))))), /* @__PURE__ */React.createElement(ReactPlayer, {
    url: URL,
    ref: reactPlayerRef,
    playing: disabled ? false : isPlaying,
    playbackRate: playbackRate,
    onPause: handlePause,
    onPlay: handlePlay,
    width: reactPlayerSize,
    height: reactPlayerSize,
    controls: showControls,
    volume: volume,
    onProgress: handleProgress,
    onDuration: handleDuration,
    "data-loaded": !isLoading,
    onEnded: onEnded,
    config: {
      file: {
        forceAudio: true
      }
    }
  }));
};

export { AUDIO_TYPES as A, ReactPlayerWrapper as R, getAudioSrc as g, styles as s };

import 'wix-rich-content-plugin-audio/dist/loadable/viewer/es/styles.viewer.min.global.css'